import consts from "@/consts.js";
import Request from './request';
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetchByMaterial(id, data) {
    return Request('get', "api/material-templates/view-by-material/" + id, data);
}

async function fetchByTemplate(id, data) {
    // 为显示unsaved的模板详情特地用post方法
    return Request('post', "api/material-templates/view-by-template/" + id, data);
}

async function fetchByShop(id, data) {
    if (!data) data = {};
    data.limit = data.limit ? data.limit : consts.limitAll; //获取全部
    return Request('post', "api/material-templates/view-by-shop/" + id, data);
}

async function fetchCombineMaterialsByShop(id) {
    return Request('get', "api/material-templates/get-combine-material-rulers/" + id);
}

async function batchSave(data, edit_flg) {
    return Request('post', "api/material-templates/batch-save?edit_flg=" + edit_flg, data);
}

async function exportsDetail(id,data) {
    // 明细导出报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/material-templates/export/'+id, data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }

async function getTemplatesMaterialGroups(id, data) {
    return Request('post', "api/material-templates/get-templates-material-groups/" + id, data);
}


async function importBatchTemplateExport(data) {
    return Request('post', "api/material-templates/import-batch-template-export", data);
}

async function batchImport(data) {// 导入
    return Request('post', "api/material-templates/batch-import", data);
}

async function batchPriceExport(data) {
    return Request('post', "api/material-templates/batch-price-export", data);
}

async function batchPriceImport(data) {//模板批量改价
    return Request('post', "api/material-templates/batch-price-import", data);
}

async function singleBatchSave(id, data) {
    return Request('get', "api/material-templates/singleBatchSave/" + id, data);
}


async function getTemplatePriceHistories(data) {
    return Request('get', "api/material-templates/get-template-price-histories", data);
}


export default {
    fetchByMaterial,
    fetchByTemplate,
    fetchByShop,
    fetchCombineMaterialsByShop,
    batchSave,
    exportsDetail,
    getTemplatesMaterialGroups,
    importBatchTemplateExport,
    batchImport,
    batchPriceExport,
    batchPriceImport,
    singleBatchSave,
    getTemplatePriceHistories,
};